import formatMoney from "../../../formatMoney";
import { parseMoney } from "./utils";

async function salesFormatReport(sales = [], taxableDate = new Date()) {
  const formattedSales = sales.reduce((acc, item) => {
    const clientId = item?.client?.id;
    if (!clientId) return acc;

    const { gross, vat, net, vatExempt, client, zeroRated, isVatable } = item;

    const nameParts = [
      client.lastName,
      client.firstName,
      client.middleName,
    ].filter(Boolean);
    const fullName =
      nameParts.length > 0 ? nameParts.join(", ") : client.contactPerson || "";
    const address = [
      client.BillingRegion,
      client.billingProvince,
      client.billingCity,
      client.billingBarangay,
      client.billingStreet,
    ]
      .filter(Boolean)
      .join(", ");
    const grossValue = parseMoney(gross || 0);
    const taxableAmount = parseMoney(isVatable ? gross : 0);
    const vatExemptValue = parseMoney(vatExempt || 0);
    const zeroRatedValue = parseMoney(zeroRated || 0);
    const vatValue = parseMoney(vat || 0);
    const netValue = parseMoney(isVatable ? net : 0);

    if (!acc[clientId]) {
      acc[clientId] = {
        //clientId,
        client: item.client,
        taxableDate: taxableDate.toISOString(),
        fullName,
        address,
        totalGross: 0,
        vatExemptAmount: 0,
        zeroRatedAmount: 0,
        taxableAmount: 0,
        vatAmount: 0,
        grossTaxableAmount: 0,
      };
    }

    acc[clientId].totalGross += grossValue;
    acc[clientId].vatExemptAmount += vatExemptValue;
    acc[clientId].zeroRatedAmount += zeroRatedValue;
    acc[clientId].netAmount += netValue;
    acc[clientId].vatAmount += vatValue;

    acc[clientId].taxableAmount += taxableAmount;

    return acc;
  }, {});

  return Object.values(formattedSales).map((s) => ({
    ...s,
    totalGross: formatMoney(
      s.taxableAmount + s.vatExemptAmount + s.zeroRatedAmount,
    ),
    vatExemptAmount: formatMoney(s.vatExemptAmount),
    zeroRatedAmount: formatMoney(s.zeroRatedAmount),
    taxableAmount: formatMoney(s.taxableAmount),
    vatAmount: formatMoney(s.vatAmount),
    grossTaxableAmount: formatMoney(s.taxableAmount + s.vatAmount),
  }));
}

export default salesFormatReport;
